import { useEffect, useState } from "react";
import log from "src/helpers/log";

const useResolveMaybePromise = <T>(
	value: T | Promise<T>,
	{ onError }: { onError?: (err: any) => void } = {},
): T | null => {
	const [resolvedValue, setResolvedValue] = useState(value instanceof Promise ? null : value);
	useEffect(() => {
		if (value instanceof Promise) {
			value
				.then((resolvedValue) => {
					setResolvedValue(resolvedValue);
				})
				.catch((err) => {
					log.error({ err }, "Failed to resolve promise");
					onError?.(err);
				});
		}
	}, [onError, value]);

	return resolvedValue;
};
export default useResolveMaybePromise;
